import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f0c3717"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.route.meta && !_ctx.route.meta.hideHeader)
      ? (_openBlock(), _createBlock(_component_Header, {
          key: 0,
          color: _ctx.route.meta.color,
          metaObj: _ctx.route.meta
        }, null, 8, ["color", "metaObj"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(!_ctx.route.meta.hideHeader ? 'ptheader' : ''),
      style: _normalizeStyle({ background: _ctx.route.meta.color })
    }, null, 6),
    (_openBlock(), _createBlock(_component_router_view, {
      key: _ctx.route.fullPath
    }))
  ]))
}